__turbopack_context__.v({
  "className": "lato_41bbb099-module__pZ9fEa__className",
  "variable": "lato_41bbb099-module__pZ9fEa__variable",
});
